export default __webpack_public_path__ + "static/media/Arch_Reg_Ital.9c0f0784.otf";